import { Box } from '@mui/material';
import * as React from 'react';
import AnnouncementTable from './announcementTable';

export default function AnnouncementLayout() {
  return (
    <Box sx={{ mt: 2 }}>
      <AnnouncementTable />
    </Box>
  );
}
